import React, { PropsWithChildren } from "react";
import {
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogContent,
  AlertDialogTrigger,
  AlertDialog,
} from "@/components/ui";
import { useTranslation } from "react-i18next";

export function PermissionAlert({
  showAlert,
  children,
}: PropsWithChildren<{ showAlert: boolean }>) {
  const { t } = useTranslation();

  if (!showAlert) {
    return children;
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("teamManagement.permissionAlert.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("teamManagement.permissionAlert.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("global.close")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
